import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UiModule } from '@freelancer/ui';
import { AiModalComponent } from './ai-modal.component';

@NgModule({
  imports: [CommonModule, UiModule],
  declarations: [AiModalComponent],
  exports: [AiModalComponent],
})
export class AiModalModule {}
